import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../../../main/services';
import { Supplier, Tender } from '../../../../models';
import { TenderContractsService, TenderSuppliersService } from '../../../../services';

@Component({
    selector: 'jft-create-supplier-bunch-table-modal',
    templateUrl: './create-supplier-bunch-table-modal.component.html',
    styleUrls: ['./create-supplier-bunch-table-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateSupplierBunchTableModalComponent implements OnInit {

    public form: UntypedFormGroup;
    public loading: boolean = false;
    public loadingTemplate: boolean = false;
    public dataTable: any[] = [];

    constructor(
        private toast: ToastService,
        private tender: Tender,
        private service: TenderContractsService,
        private activeModal: NgbActiveModal,
        private supplierService: TenderSuppliersService,
    ) {
    }

    public ngOnInit() {
        this.dataTable = this.getDefaultDataTable();
    }

    public getFormGroupErrorClasses(control: AbstractControl): {} {
        return { 'is-invalid': control.invalid && control.touched };
    }

    public showErrorBlock(control: AbstractControl): boolean {
        return control.errors && (control.dirty || control.touched);
    }

    public close() {
        this.activeModal.dismiss();
    }

    public downloadTemplate($event: Event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.loadingTemplate) {
            return;
        }
        this.loadingTemplate = true;

        this.supplierService.downloadContactsTemplate().subscribe((response: Blob) => {
            const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'JFT - Import Contacts Template.xlsx';
            link.click();
            window.URL.revokeObjectURL(url);
            this.loadingTemplate = false;
        }, () => {
            this.loadingTemplate = false;
        });
    }

    public submitSuppliers() {
        this.dataTable.forEach((row, index) => {
            if (row.contact.email) {
                this.submitSupplier(row, index);
            }
        });
    }

    public submitSupplier(supplier, index) {
        this.loading = true;

        this.supplierService.createSupplier(this.tender, supplier).subscribe((data) => {
            this.loading = false;
            this.activeModal.close({ success: true });
            this.toast.success(`${supplier.name} added`);
        }, (e) => {
            this.loading = false;
            this.toast.error(e);
        });
    }

    public getDefaultDataTable() {

        let defaultSupplier = Supplier.create({
            name: 'Company Legal Name',
            contact: {
                first_name: 'First Name',
                last_name: 'Last Name',
                email: 'email_example@mailserver.com',
                phone: '123123123',
            }
        });

        return [
            defaultSupplier.toJSON()
        ];
    }

}
